import axios from 'axios';
import {
  prometheusPasskey,
  prometheusUrl,
  prometheusUsername,
} from '../constants/config';

export const sendMetricsToPrometheus = (metrics: string) => {
  if (!prometheusUrl) {
    return;
  }

  axios
    .post(prometheusUrl, metrics, {
      auth: { username: prometheusUsername, password: prometheusPasskey },
    })
    .catch(e => {
      // oxlint-disable-next-line no-console
      console.error(`Metric to Prometheus failed with: ${e}`);
    });
};
